import * as React from "react";
import {Box, Button, Typography} from "@mui/joy";
import {PhoneOutlined} from "@mui/icons-material";

const IMAGE_PATH = '/images/';

export default function NavigationBar({selectedService, franchise}) {
    return (
        <header style={{'width': '100%'}}>
            <Box sx={(theme) => ({
                display: 'flex', justifyContent: 'space-between', width: '100%', height: '100%',
                [theme.breakpoints.down('md')]: {
                    flexDirection: 'column',
                    boxSizing: 'border-box',
                    justifyContent: 'center',
                    alignItems: 'center',
                }
            })}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    height: '100%',
                    width: '90%',
                    '@media (max-width:900px)': {
                        justifyContent: 'center',
                    },
                }}>
                    <Box
                        sx={{
                            '@media (max-width:300px)': {
                                display: 'none',
                            },
                        }}
                    >
                        <a href={"/"}>
                            <img style={{"height": "50px"}} src={`${IMAGE_PATH}yeticlean-logo-transparent.png`} alt="Yeti Clean Logo"/>
                        </a>
                    </Box>
                    <Box
                        sx={{
                            '@media (min-width:300px)': {
                                display: 'none',
                            },
                        }}
                    >
                        <a href={"/"}>
                            <img style={{"height": "50px"}} src={`${IMAGE_PATH}yeti.png`} alt="Yeti Clean Logo"/>
                        </a>
                    </Box>

                </Box>
                <Typography
                    level={"title-lg"}
                    sx={(theme) => ({
                        marginTop: "15px",
                        marginBottom: "15px",
                        [theme.breakpoints.up("md")]: {
                            display: "none",
                        },
                    })}
                >

                    {franchise && franchise.twilio_phone ? (
                        <a href={`tel:${franchise.twilio_phone}`} style={{textDecoration: "none", color: "inherit",  marginBottom: '5px'}}>
                            Mobile: {franchise.twilio_phone}
                        </a>
                    ) : (
                        <a href="tel:+447488881323" style={{textDecoration: "none", color: "inherit", marginBottom: '5px'}}>
                            Mobile: +44 7488 881323
                        </a>
                    )}


                </Typography>

                <Box sx={(theme) => ({
                    display: 'flex', justifyContent: 'end', alignItems: 'center',
                    [theme.breakpoints.down('md')]: {
                        display: 'none',
                    }
                })}>
                    <Box sx={(theme) => ({
                        display: 'flex', alignItems: 'center', justifyContent: 'end',
                        [theme.breakpoints.down('md')]: {
                            marginTop: '10px',
                            flexDirection: 'column',
                            textAlign: 'center',
                        }
                    })}>
                        <Button endDecorator={<PhoneOutlined/>}>
                            {franchise && franchise.twilio_phone ? (
                                <a href={`tel:${franchise.twilio_phone}`}
                                   style={{textDecoration: "none", color: "inherit", whiteSpace: "nowrap"}}>
                                    Mobile: {franchise.twilio_phone}
                                </a>
                            ) : (
                                <a href="tel:+447488881323" style={{textDecoration: "none", color: "inherit", whiteSpace: "nowrap"}}>
                                    Mobile: +44 7488 881323
                                </a>
                            )}
                        </Button>

                    </Box>

                </Box>
            </Box>
        </header>
    )

}